import React, { useMemo } from "react"
import TableContainer from "components/tables/TableContainer"
import { Button } from "reactstrap"
import { JPYFormat } from "util/currencyFormat"

const Table = ({
  content,
  page,
  size,
  count,
  setSize,
  setPage,
  redirect,
  total,
}) => {
  const listDataTable = useMemo(() => {
    if (!content) return []
    const list = content.map((v, i) => ({
      id: v.id,
      path: v.path,
      supplierName: v.supplierName,
      storeName: v.storeName,
      customerName: v.customerName,
      orderNumber: v.orderNumber,
      status: v.status,
      type: v.type,
      productName: v.productName,
      orderDate: v.orderDate,
      fabricCompanyName: v.fabricCompanyName,
      fabricNumber: v.fabricNumber,
      unitPrice: v.unitPrice ? JPYFormat(v.unitPrice) : "-",
      scale: v.scale,
      fabricCost: v.fabricCost ? JPYFormat(v.fabricCost) : "-",
      ancientTimes: v.ancientTimes ? JPYFormat(v.ancientTimes) : "-",
      grossProfit: v.grossProfit ? JPYFormat(v.grossProfit) : "-",
      deliveryDate: v.deliveryDate,
      paymentStatus: v.paymentStatus,
      bastingDate: v.bastingDate,
    }))
    list.push({
      id: "",
      path: "",
      supplierName: "",
      storeName: "",
      customerName: "",
      orderNumber: "",
      status: "",
      type: "",
      productName: "",
      orderDate: "",
      fabricCompanyName: "",
      fabricNumber: "",
      unitPrice: "",
      scale: "小計",
      fabricCost: total.subTotal?.fabricCost
        ? JPYFormat(total.subTotal?.fabricCost)
        : 0,
      ancientTimes: total.subTotal?.ancientTimes
        ? JPYFormat(total.subTotal?.ancientTimes)
        : 0,
      grossProfit: total.subTotal?.grossProfit
        ? JPYFormat(total.subTotal?.grossProfit)
        : 0,
      deliveryDate: "",
      paymentStatus: "",
    })
    list.push({
      id: "",
      path: "",
      supplierName: "",
      storeName: "",
      customerName: "",
      orderNumber: "",
      status: "",
      type: "",
      productName: "",
      orderDate: "",
      fabricCompanyName: "",
      fabricNumber: "",
      unitPrice: "",
      scale: "総合計",
      fabricCost: total.grandTotal?.fabricCost
        ? JPYFormat(total.grandTotal?.fabricCost)
        : 0,
      ancientTimes: total.grandTotal?.ancientTimes
        ? JPYFormat(total.grandTotal?.ancientTimes)
        : 0,
      grossProfit: total.grandTotal?.grossProfit
        ? JPYFormat(total.grandTotal?.grossProfit)
        : 0,
      deliveryDate: "",
      paymentStatus: "",
    })
    return list
  }, [content])

  const columns = useMemo(
    () => [
      {
        Header: "取引先",
        accessor: "supplierName",
        defaultCanSort: false,
      },
      {
        Header: "店舗",
        accessor: "storeName",
        defaultCanSort: false,
      },
      {
        Header: "受注番号",
        accessor: "orderNumber",
        defaultCanSort: false,
      },
      {
        Header: "ステータス",
        accessor: "status",
        defaultCanSort: false,
      },
      {
        Header: "顧客名",
        accessor: "customerName",
        defaultCanSort: false,
      },
      {
        Header: "区分",
        accessor: "type",
        defaultCanSort: false,
      },
      {
        Header: "商品",
        accessor: "productName",
        defaultCanSort: false,
      },
      {
        Header: "受注日",
        accessor: "orderDate",
        defaultCanSort: false,
      },
      {
        Header: "生地商社",
        accessor: "fabricCompanyName",
        defaultCanSort: false,
      },
      {
        Header: "生地番号",
        accessor: "fabricNumber",
        defaultCanSort: false,
      },
      {
        Header: "生地単価",
        accessor: "unitPrice",
        defaultCanSort: false,
        Cell: cell => <div className="w-full text-end">{cell.value}</div>,
      },
      {
        Header: "用尺",
        accessor: "scale",
        defaultCanSort: false,
      },
      {
        Header: "生地代",
        accessor: "fabricCost",
        defaultCanSort: false,
        Cell: cell => <div className="w-full text-end">{cell.value}</div>,
      },
      {
        Header: "上代",
        accessor: "ancientTimes",
        defaultCanSort: false,
        Cell: cell => <div className="w-full text-end">{cell.value}</div>,
      },
      {
        Header: "粗利",
        accessor: "grossProfit",
        defaultCanSort: false,
        Cell: cell => <div className="w-full text-end">{cell.value}</div>,
      },
      {
        Header: "仮縫い日",
        accessor: "bastingDate",
        defaultCanSort: false,
      },
      {
        Header: "納品日",
        accessor: "deliveryDate",
        defaultCanSort: false,
      },
      {
        Header: "支払いステータス",
        accessor: "paymentStatus",
        defaultCanSort: false,
      },
      {
        Header: "",
        accessor: "id",
        Cell: cell => {
          // console.log("150", cell.row.original.id)
          if (!cell.row.original.id) return ""
          return (
            <Button
              className="button"
              onClick={() =>
                redirect(cell.row.original.id, cell.row.original.path)
              }
            >
              詳細
            </Button>
          )
        },
      },
    ],
    []
  )

  return (
    <>
      <TableContainer
        page={page + 1}
        size={size}
        count={count}
        setPageSize={val => setSize(val)}
        setParams={params => setPage(params.page)}
        columns={columns}
        data={listDataTable}
        pagination
      />
    </>
  )
}

export default Table
